<template>
    <a-drawer width="80%" :label-col="4" :wrapper-col="14" :maskClosable="false" :visible="open" @close="onClose">
        <a-divider orientation="left">
            <b>{{ formTitle }}</b>
        </a-divider>
        <a-form-model ref="form" :model="form" :rules="rules">

            <a-form-model-item label="名称" prop="discountName">
                <a-input v-model="form.discountName"/>
            </a-form-model-item>

            <a-form-model-item label="启用状态" prop="status">
                <a-select v-model="form.status" placeholder="请选择">
                    <a-select-option :value="0">启用</a-select-option>
                    <a-select-option :value="1">禁用</a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item label="人群" prop="crowd">
                <a-input v-model="form.crowd" />
            </a-form-model-item>

            <a-form-model-item label="人群和购买记录关系" prop="relationship">
                <a-radio-group v-model="form.relationship">
                    <a-radio :value="'and'">and</a-radio>
                    <a-radio :value="'or'">or</a-radio>
                </a-radio-group>
            </a-form-model-item>

            <a-form-model-item label="有无会员购买记录" prop="boughtVip">
                <a-radio-group v-model="form.boughtVip">
                    <a-radio :value="0">有</a-radio>
                    <a-radio :value="1">无</a-radio>
                </a-radio-group>
            </a-form-model-item>

            <a-form-model-item label="用户Ids" prop="userIds">
                <a-input v-model="form.userIds" />
            </a-form-model-item>

            <a-form-model-item  label="截止时间" prop="expireTime" >
                <a-date-picker  :allow-clear="true" size="default" v-model="form.expireTime" placeholder="截止时间" value-format="YYYY-MM-DD HH:mm" format="YYYY-MM-DD HH:mm">
                </a-date-picker>
            </a-form-model-item>

            <a-form-model-item label="次数" prop="count">
                <a-input v-model="form.count" />
            </a-form-model-item>
            <a-form-model-item label="优惠VIP类型(周月年季)" prop="vipType">
                <a-select v-model="form.vipType" placeholder="请选择" allowClear>
                    <a-select-option :value="1">周卡</a-select-option>
                    <a-select-option :value="2">月卡</a-select-option>
                    <a-select-option :value="4">季卡</a-select-option>
                    <a-select-option :value="3">年卡</a-select-option>
                </a-select>
            </a-form-model-item>

            <a-form-model-item label="IOS优惠商品Id" prop="iosCode">
                <a-input v-model="form.iosCode" />
            </a-form-model-item>

            <a-form-model-item label="Google优惠商品Id" prop="googleLevel">
                <a-input v-model="form.googleLevel" />
            </a-form-model-item> 

            <div class="bottom-control">
                <a-space>
                    <a-button type="primary" :loading="submitLoading" @click="submitForm">
                        保存
                    </a-button>
                    <a-button type="dashed" @click="cancel">
                        取消
                    </a-button>
                </a-space>
            </div>
        </a-form-model>
    </a-drawer>
</template>

<script>
import { detail , add, update} from '@/api/discount/discount'
import Editor from '@/components/Editor'

export default {
    name: 'CreateForm',
    props: {
    },
    components: {
        Editor
    },
    data() {
        return {
            isJup: false,
            listAll: [],
            submitLoading: false,
            formTitle: '',
            // 表单参数
            form: {
                id: null,

                discountName: null,

                type: '',

                crowd: '',

                boughtVip: '',

                status: '',

                userIds: '',

                expireTime: '',

                count: null,

                vipType: null,

                iosCode: null,

                googleLevel: null,

                relationship: null

            },
            // 1增加,2修改
            formType: 1,
            open: false,
            rules: {
            }
        }
    },
    filters: {
    },
    created() {
    },
    computed: {
    },
    watch: {
    },
    mounted() {
    },
    methods: {
        onClose() {
            this.reset();
            this.open = false
        },
        // 取消按钮
        cancel() {
            this.reset()
            this.open = false
        },
        // 表单重置
        reset() {
            this.formType = 1
            this.form = {
                id: null,
                type: '',
                discountName: null,
                crowd: '',
                status: '',
                boughtVip: '',
                userIds: '',
                expireTime: null,
                count: null,
                vipType: null,
                iosCode: null,
                googleLevel: null,
                relationship: null,
            }
            this.$nextTick(() => {
                if (this.$refs.form) {
                    this.$refs.form.resetFields()
                }
            })
        },
        /** 新增按钮操作 */
        handleAdd(row) {
            this.reset()
            this.formType = 1
            this.open = true
            this.formTitle = '添加'
        },
        /** 修改按钮操作 */
        handleUpdate(row, ids) {
            this.reset()
            this.formType = 2
            const id = row ? row.id : ids
            detail({ 'id': id }).then(response => {
                this.form = response.data
                debugger
                console.log(this.form)
                this.open = true
                this.formTitle = '修改'
            })
        },
        /** 提交按钮 */
        submitForm: function () {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.submitLoading = true
                    if (this.form.id !== undefined && this.form.id !== null) {
                        console.log('表单内容：', this.form)
                        update(this.form).then(response => {
                            this.$message.success(
                                '修改成功',
                                3
                            )
                            this.open = false
                            this.$emit('ok')
                        }).finally(() => {
                            this.submitLoading = false
                        })
                    } else {
                        add(this.form).then(response => {
                            this.$message.success(
                                '新增成功',
                                3
                            )
                            this.open = false
                            this.$emit('ok')
                        }).finally(() => {
                            this.submitLoading = false
                        })
                    }
                } else {
                    return false
                }
            })
        }
    }
}
</script>
  